// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import querystring from 'querystring';

import { Auth } from 'aws-amplify';
import React, { useEffect, useState, useContext } from 'react';
import { Link, RouteProps, Redirect } from 'react-router-dom';
import EmailImage from './assets/email.png';
import LoginLayout from '../../layouts/LoginLayout';
import ForgetPasswordForm from './ForgetPasswordForm';
import LogoImage from '../../assets/images/login-logo.svg'
import BackArrowImg from '../../assets/images/back-login-arrow.svg';
import Center from '../../components/Center';
import MemberContext from '../../contexts/MemberContext';
import { FormattedMessage, useIntl } from 'react-intl';
import S from './styles';
import { getQueryParams, useQuery } from '../../lib/utility';
function getToken(hash: string) {
  return hash
    .split('&')
    .map((chunk) => {
      const split = chunk.split('=');
      return {
        [split[0].replace('#', '')]: split[1]
      };
    })
    .reduce((pre, now) => ({ ...pre, ...now }), {});
}

const ForgetPasswordPage = (props: RouteProps): JSX.Element => {
  const { sent, email } = getQueryParams(useQuery());
  const [resend, setResend] = useState<boolean>(false);
  const [maximum, setMaximum] = useState<boolean>(false);
  const member = useContext(MemberContext);
  const intl = useIntl();
  if (member.isLogin) {
    return (
      <Redirect to="/home"></Redirect>
    )
  }
  if (props.location?.hash) {
    console.log(querystring.parse(props.location.hash));
    const token = getToken(props.location.hash);
    console.log(token);
    console.log(token.id_token);
  }
  useEffect(() => {
    if (resend) {
      console.log({ resend })
      setTimeout(() => {
        console.log({ resend })
        setResend(false)
      }, 30000);
    }
  }, [resend]);
  const resendCode = () => {
    console.log({ email })
    Auth.forgotPassword(email)
      .then(data => {
        console.log({ data });
        setResend(true)
        // setMessage('忘記密碼信件寄送成功，5秒鐘後自動導入Login頁面');
      })
      .catch(err => {
        console.log({ err });
        setMaximum(true)
      })
      .finally(() => {
        console.log('finally');
      })
  }

  if (sent) {
    return (
      <LoginLayout>
        <S.ConfirmWrapper>
          <S.ConfirmImg src={EmailImage} alt="" />
          <S.ConfirmDescriptionWrapper>
            <S.ConfirmTitle>{intl.formatMessage({ id: 'J046' })}</S.ConfirmTitle>
            <S.ConfirmDescription>
              {intl.formatMessage({ id: 'J047' })}
            </S.ConfirmDescription>
          </S.ConfirmDescriptionWrapper>
          <S.Wait30Description>{!maximum ? (resend && `*${intl.formatMessage({ id: 'J050' })}`):' Reach Limit'}</S.Wait30Description>
          <S.ConfirmButtonWrapper>
            <S.ConfirmLoginButton as={Link} to={'/login'}>{intl.formatMessage({ id: 'J048' })}</S.ConfirmLoginButton>
            <S.ConfirmRetryButton disabled={resend || maximum } onClick={resendCode}>{intl.formatMessage({ id: 'J049' })}</S.ConfirmRetryButton>
          </S.ConfirmButtonWrapper>
        </S.ConfirmWrapper>
      </LoginLayout>
    )
  } else {
    return (
      <S.LoginLayout>
        <S.Container>
          <S.GoToLoginPage to={'/login'}>
            <S.BackArrow src={BackArrowImg} />{intl.formatMessage({ id: 'J040' })}
          </S.GoToLoginPage>
          <Center>
            <S.HeaderContainer>
              <S.Logo src={LogoImage} />
              <S.Title>{intl.formatMessage({ id: 'J041' })}</S.Title>
              <S.SubTitle>
                {intl.formatMessage({ id: 'J042' })}
              </S.SubTitle>
            </S.HeaderContainer>
          </Center>
          <S.ForgetPasswordFormContainer>
            <ForgetPasswordForm />
          </S.ForgetPasswordFormContainer>
        </S.Container>
      </S.LoginLayout>
    );
  }
}
export { ForgetPasswordPage as default }
